import { IconAtSign } from 'featherico';
import { getCurrentUser } from '../../../../services/CurrentUser';
import ToolbarButton from '../../Toolbar/button';
import * as autocompletion from '../../helpers/autocompletion';
import UserSearcher from './UserSearcher';
import Mention from './format';

const NAME = 'mentions';
const TRIGGER = '@';
const TRIGGERS = [{ type: 'string', value: TRIGGER }];

const searcher = new UserSearcher();

function Choice(props) {
    const { item } = props;
    return (
        <autocompletion.ResultsItem {...props}>
            <img src={`${item.logo}?size=20`} alt="" />
            <span>{item.name}</span>
        </autocompletion.ResultsItem>
    );
}

class Mentions {
    constructor(quill) {
        const container = quill.addContainer('ql-mention');
        this.instance = autocompletion.createInstance({
            quill,
            container,
            wrapperComponent: autocompletion.ResultsContainer,
            itemComponent: Choice,
            moreItemsComponent: autocompletion.ResultsMoreItems,
            maxItemsShown: 5,
            itemToKey: item => item.id,
            onSearch: query => searcher.search(query.string.slice(1), getCurrentUser()),
            onSelect: (item, query) => {
                this.instance.hide();
                autocompletion.replaceQueryWithEmbed(quill, query, Mention.blotName, {
                    value: item.name,
                    serialization: `${TRIGGER}${item.loginname}`,
                });
            },
        });

        this.instance.listen(TRIGGERS);
    }

    check = index => this.instance.checkDeferred({ index, length: 0 }, TRIGGERS);
}

export const name = NAME;
export const handler = Mentions;
export const formats = [Mention];

export const toolbarElements = [
    {
        key: 'mentions',
        type: 'button',
        component: ({ quill, getLastSelection }) => {
            const onClick = () => {
                const { index } = getLastSelection();
                const nextIndex = index + TRIGGER.length;
                quill.insertText(index, TRIGGER, 'user');
                quill.setSelection(nextIndex);
                quill.getModule(NAME).check(nextIndex);
            };
            return (
                <ToolbarButton onClick={onClick} title="Mention">
                    <IconAtSign />
                </ToolbarButton>
            );
        },
    },
];
